"use client";
// components/soft-modern/SpecsTabs.tsx — tabbed spec sheet (one category
// visible at a time), matching the TelemetriFa 120 Soft Modern design.
import { useState } from "react";

export type SpecCategory = {
    key: string;
    label: string;
    items: { label: string; value: string }[];
};

export default function SpecsTabs({ categories, isRtl }: { categories: SpecCategory[]; isRtl?: boolean }) {
    const [active, setActive] = useState(0);
    const current = categories[active];

    return (
        <div>
            <div className="mb-6 flex flex-wrap gap-2">
                {categories.map((cat, i) => (
                    <button
                        key={cat.key}
                        type="button"
                        onClick={() => setActive(i)}
                        className={`min-h-11 rounded-xl px-[17px] text-[13.5px] font-bold transition ${
                            i === active
                                ? "bg-[var(--sm-teal)] text-white shadow-[0_8px_20px_rgba(13,148,136,.28)]"
                                : "bg-[#f1f5f9] text-[#334155] hover:bg-[#e2e8f0]"
                        }`}
                    >
                        {cat.label}
                    </button>
                ))}
            </div>

            <div className="rounded-[24px] bg-[var(--sm-bg)] p-[10px]">
                <div
                    className="grid gap-2.5"
                    style={{ gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 300px), 1fr))" }}
                >
                    {current.items.map((item, idx) => (
                        <div key={idx} className={`rounded-[18px] bg-white px-5 py-[17px] ${isRtl ? "text-right" : ""}`}>
                            <dt className="m-0 text-[13px] font-bold text-[var(--sm-muted)]">{item.label}</dt>
                            <dd className="m-0 mt-1.5 text-[15px] font-semibold leading-[1.75] text-[var(--sm-ink)]">
                                {item.value}
                            </dd>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
